import { REDUCER } from '../reducers/reducersConst';

/**
 * SCHOOL REDUCER
 */

let defaultSchoolState = {
  loadedSchoolInfo: false, // Da por válida la escuela cargada cuando su valor es 'true'
  school: {
    id: -1,
    name: '',
    ltiConsumerKey: '',
    institutionId: undefined,
    ltiConsumerPassword: '',
    createdAt: '',
    updatedAt: '',
    customer: {
      id: -1
    }
  }
};

export let school = (state = defaultSchoolState, action) => {
  switch (action.type) {
    case REDUCER.SCHOOL.SET_SCHOOL_DATA:
      return {
        ...state,
        schools: action.schools
      };
    case REDUCER.SCHOOL.SET_SCHOOL_INFO:
      return {
        ...state,
        school: action.school,
        loadedSchoolInfo: true
      };
    case REDUCER.SCHOOL.SET_LOADED_SCHOOL_INFO:
      return {
        ...state,
        loadedSchoolInfo: action.loadedSchoolInfo
      };
    default:
      return state;
  }
};
